import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { refreshUser, logout } from '../services/auth';
import toast from '../services/toast';
import { compartilhar } from '../services/share';
import { parseDataSQL } from '../utils/dataJogo';
import Icon from '../components/Icon';
import './Perfil.css';

function statusBadge(s) {
  if (s === 'APROVADO') return <span className="badge badge-success">Aprovado</span>;
  if (s === 'REJEITADO') return <span className="badge badge-danger">Rejeitado</span>;
  return <span className="badge badge-warning">Pendente</span>;
}

export default function Perfil() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [palpites, setPalpites] = useState([]);
  const [comprovantes, setComprovantes] = useState([]);
  const [premios, setPremios] = useState([]);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({});
  const [senhaForm, setSenhaForm] = useState({ senhaAtual: '', novaSenha: '', confirmarSenha: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/usuarios/perfil').then(data => {
      setUser(data.user);
      setPalpites(data.palpites);
      setComprovantes(data.comprovantes);
      setPremios(data.premios);
      setForm({ nome: data.user.nome, whatsapp: data.user.whatsapp });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  async function salvarPerfil(e) {
    e.preventDefault();
    try {
      await api.put('/usuarios/perfil', { nome: form.nome, whatsapp: form.whatsapp });
      const u = await refreshUser();
      setUser(u);
      toast.success('Perfil atualizado!');
      setEditando(false);
    } catch (err) {
      toast.error(err.message);
    }
  }

  async function alterarSenha(e) {
    e.preventDefault();
    try {
      await api.post('/usuarios/alterar-senha', senhaForm);
      toast.success('Senha alterada com sucesso!');
      setSenhaForm({ senhaAtual: '', novaSenha: '', confirmarSenha: '' });
    } catch (err) {
      toast.error(err.message);
    }
  }

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="perfil">
      <div className="perfil-card">
        <div className="perfil-avatar-ring">
          <div className="perfil-avatar-placeholder">{user?.nome?.[0]}</div>
        </div>
        <h2 className="perfil-nome">{user?.nome}</h2>
        <p className="perfil-email">{user?.email}</p>
        <div className="perfil-stats">
          <div className="stat"><span className="stat-val">{user?.pontos ?? 0}</span><span className="stat-lbl">Ranking</span></div>
          <div className="stat-divider" />
          <div className="stat"><span className="stat-val">{user?.saldo_resgate ?? user?.pontos ?? 0}</span><span className="stat-lbl">Saldo</span></div>
          <div className="stat-divider" />
          <div className="stat"><span className="stat-val">{palpites.filter(p => p.pontos_ganhos > 0).length}</span><span className="stat-lbl">Acertos</span></div>
          <div className="stat-divider" />
          <div className="stat"><span className="stat-val">{palpites.length}</span><span className="stat-lbl">Palpites</span></div>
        </div>
        <div className="perfil-actions">
          <button className="btn btn-secondary" onClick={() => setEditando(!editando)}><Icon name="edit" size={13} /> Editar Perfil</button>
          <button className="btn btn-primary" onClick={() => navigate('/comprovante')}><Icon name="wallet" size={13} /> Enviar PIX</button>
        </div>
        <button className="btn btn-secondary btn-block" style={{ marginTop: 10, fontSize: 13 }} onClick={() => compartilhar(user?.pontos)}>
          <Icon name="share" size={13} /> Compartilhar o Palpitar
        </button>
        <button className="btn btn-gold btn-block" style={{ marginTop: 10, fontSize: 13 }} onClick={() => navigate('/cupons')}>
          <Icon name="gift" size={13} /> Possui um cupom?
        </button>
      </div>

      {editando && (
        <div className="card" style={{ marginBottom: 16 }}>
          <h3 style={{ marginBottom: 16, fontWeight: 700 }}>Editar Dados</h3>
          <form onSubmit={salvarPerfil}>
            <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} /></div>
            <div className="form-group"><label>WhatsApp</label><input value={form.whatsapp} onChange={e => setForm({ ...form, whatsapp: e.target.value })} /></div>
            <button type="submit" className="btn btn-primary btn-block">Salvar Dados</button>
          </form>

          <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: '20px 0' }} />

          <h3 style={{ marginBottom: 16, fontWeight: 700 }}>Alterar Senha</h3>
          <form onSubmit={alterarSenha}>
            <div className="form-group">
              <label>Senha atual</label>
              <input type="password" value={senhaForm.senhaAtual} onChange={e => setSenhaForm({ ...senhaForm, senhaAtual: e.target.value })} placeholder="••••••••" />
            </div>
            <div className="form-group">
              <label>Nova senha</label>
              <input type="password" value={senhaForm.novaSenha} onChange={e => setSenhaForm({ ...senhaForm, novaSenha: e.target.value })} placeholder="••••••••" />
            </div>
            <div className="form-group">
              <label>Confirmar nova senha</label>
              <input type="password" value={senhaForm.confirmarSenha} onChange={e => setSenhaForm({ ...senhaForm, confirmarSenha: e.target.value })} placeholder="••••••••" />
            </div>
            <button type="submit" className="btn btn-secondary btn-block">Alterar Senha</button>
          </form>
        </div>
      )}

      <section className="perfil-section">
        <h3>Últimos Comprovantes</h3>
        {comprovantes.slice(0, 3).map(c => (
          <div key={c.id} className="mini-item">
            <span style={{ fontSize: 12, color: 'var(--text2)' }}>{parseDataSQL(c.created_at).toLocaleDateString('pt-BR')}</span>
            {statusBadge(c.status)}
          </div>
        ))}
        {comprovantes.length === 0 && <p className="perfil-empty">Nenhum comprovante.</p>}
      </section>

      <section className="perfil-section">
        <h3>Prêmios Resgatados</h3>
        {premios.slice(0, 3).map(p => (
          <div key={p.id} className="mini-item">
            <span className="mini-item-label"><Icon name="gift" size={13} /> {p.premiacao_nome}</span>
            <span style={{ fontSize: 12, color: 'var(--primary)', fontWeight: 700 }}>{p.pontuacao_necessaria} pts</span>
          </div>
        ))}
        {premios.length === 0 && <p className="perfil-empty">Nenhum prêmio resgatado.</p>}
      </section>

      <button className="btn btn-danger btn-block" style={{ marginTop: 16 }} onClick={() => { logout(); navigate('/login'); }}>
        Sair da Conta
      </button>
    </div>
  );
}
